import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImagePreviewPipe } from './image-preview.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [ImagePreviewPipe],
  exports: [ImagePreviewPipe],
  providers: [ImagePreviewPipe],
})
export class ImagePreviewModule {
}
